import * as log from "loglevel";
import * as marked from "marked";
import * as React from "react";

import { Message } from "semantic-ui-react";

declare var hopscotch: any;

interface IProjectDashboardProps{
	releaseNote;
}

interface IProjectDashboardState{
}



export class ReleaseNote extends React.Component<IProjectDashboardProps, IProjectDashboardState>{
	constructor(props, state){
		super(props, state);
	}

	render(){
		return (
			<Message>
				<Message.Header>JUMP Release {this.props.releaseNote.releaseDate}</Message.Header>
				<Message.Content>
					<p dangerouslySetInnerHTML={{"__html": marked(this.props.releaseNote.text, {"sanitize": true}) }} />
				</Message.Content>
			</Message>
		);
	}
}




// WEBPACK FOOTER //
// ./src/components/release-note.tsx